import { newApi } from './api.instance';
import { MapSearchBody } from '../../features/map/dtos';

export class MapsApis {
  public static getMapConfig = async () => {
    return newApi()
      .get('/v1/maps/configurations')
      .then(({ data }) => data);
  };

  public static getMapAreas = async (
    body: MapSearchBody,
    language?: string
  ) => {
    return newApi()
      .get('/v1/maps/areas', {
        params: body,
        headers: { 'Accept-Language': language }
      })
      .then(({ data }) => data);
  };

  public static getMapCompounds = async (
    body: MapSearchBody,
    language?: string
  ) => {
    return newApi()
      .get('/v1/maps/compounds', {
        params: body,
        headers: { 'Accept-Language': language }
      })
      .then(({ data }) => data);
  };

  public static getAllMapCompounds = async (body: any, language?: string) => {
    return newApi()
      .get('/v1/maps/compounds/all', {
        params: body,
        headers: { 'Accept-Language': language }
      })
      .then(({ data }) => data);
  };

  public static getNawyNowMap = async (
    body: MapSearchBody,
    language?: string
  ) => {
    return newApi()
      .get('/v1/maps/compounds/nawy-now', {
        params: body,
        headers: { 'Accept-Language': language }
      })
      .then(({ data }) => data);
  };
  public static getNawyNowMapAreas = async (
    body: MapSearchBody,
    language?: string
  ) => {
    return newApi()
      .get('/v1/maps/areas/nawy-now', {
        params: body,
        headers: { 'Accept-Language': language }
      })
      .then(({ data }) => data);
  };
}
